<template>
    <section class="login-section">
      <div class="login-box">
        <a href="#" class="link-block-63 w-inline-block">
          <img loading="lazy" src="@/assets/images/Rx-Pros-icon-web.png" alt="" class="image-555">
        </a>
        <div class="first-slide">
          <div class="header-sub-div">
            <div class="register-header">Reset password</div>
          </div>
          <div class="register-form w-form">
            <form @submit.prevent="onSubmit">
              <label for="password" class="label">Enter new password</label>
              <input 
                class="register-text-field w-input" 
                maxlength="256" 
                name="password" 
                data-name="Password" 
                placeholder="Enter password" 
                type="password" 
                id="password" 
                required=""
                v-model="password"
              >
              <label for="repeat-password" class="label">Re-enter password</label>
              <input 
                class="register-text-field w-input" 
                maxlength="256" 
                name="repeat-password" 
                data-name="Repeat Password" 
                placeholder="Repeat password" 
                type="password" 
                id="repeat-password" 
                required=""
                v-model="repeat_password"
              >
              <div class="w-form-fail" style="display:block;" v-if="errorPassword">
                <div>Passwords do not match!</div>
              </div>
              <button 
                type="submit"
                class="submit-button-13 w-button"
                :disabled="submitted || errorPassword"
              >
                <div v-if="submitted">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                    </circle>
                  </svg>
                </div>
                <div v-else>
                  Reset Password
                </div>
              </button>
              <div class="text-block-203">
                <router-link to="/login" class="link-12">Back to login <span class="text-span-182">-&gt;</span></router-link>
              </div>
            </form>
            <div class="w-form-done" v-if="success">
              <svg class="form-warning-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
              </svg>
              <div>Password changed successfully. Click Here to <router-link to="/login">Login</router-link></div>
            </div>
            <div class="w-form-fail" style="display:block;" v-if="err">
              <div>Link expired!</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'ResetPassword',
    props: ['baseUrl'],
    data() {
      return {
        password: '',
        repeat_password: '',
        submitted: false,
        success: false,
        err: false
      }
    },
    computed: {
      errorPassword() {
        if (this.password !== this.repeat_password && this.repeat_password !== '') {
          return true;
        }
        return false;
      }
    },
    methods: {
      onSubmit() {
        this.submitted = true;
        this.err = false;
        this.$axios.post(this.baseUrl + '/api/password-reset', {
          password: this.password,
          token: this.$route.params.token
        }).then(response => {
          if (response.data.status == 'success') {
            this.success = true;
            this.submitted = false;
            this.$router.push('/login');
          } else {
            this.submitted = false;
            this.err = true;
          }
        });
      },
    }
  }
  </script>
  
  <style scoped>
  .w-form-done {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 16px;
    margin-top: 10px;
    background-color: #fef3c7;
    border: 1px solid #f59e0b;
    border-radius: 6px;
    color: #92400e;
    text-align: left;
  }

  .form-warning-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-top: 2px;
    color: #f59e0b;
  }
  </style>